import { Button } from "design-system/atoms/Button"
import { MarkdownRenderer } from "design-system/organisms/chat/MarkdownRenderer"
import config from "lib/config"
import { useTranslation } from "react-i18next"
import { CampaignDetailResponseDataSchema } from "schema"
import { toast } from "sonner"
import { z } from "zod"

function buildUrl(uuid: string) {
  // NOTE: We have a redirect in the landing page, so the url looks prettier 💅
  // Check landing's next.config.js
  if (config.isProduction) {
    return `https://permut.com/c/${uuid}`
  }

  // For other envs, we just use the ugly endpoint
  return `${config.apiEndpoint}/api/v1/link/${uuid}`
}

type Props = {
  campaign: z.infer<typeof CampaignDetailResponseDataSchema>
}

export function LinkMetadataInfo({ campaign }: Props) {
  const { t } = useTranslation()

  const urlEndpoint = buildUrl(campaign.uuid)

  const url = `\`\`\`yml
${urlEndpoint}
\`\`\`
`

  return (
    <div className="flex flex-col gap-2">
      {campaign.uuid && (
        <MarkdownRenderer className="text-sm **:break-all **:whitespace-pre-wrap">
          {url}
        </MarkdownRenderer>
      )}
      <div className="flex items-start">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => {
            navigator.clipboard.writeText(urlEndpoint)
            toast.success(t("campaigns.trigger.metadata.link.copyLinkSuccess"))
          }}
        >
          {t("campaigns.trigger.metadata.link.copyLink")}
        </Button>
      </div>
    </div>
  )
}
